export const antdTheme = {
  token: {
    colorPrimary: "#1b91a9",
    colorSuccess: "#15a586",
    colorInfo: "#1b91a9",
    colorWarning: "#faad14",
    colorError: "#ff4d4f",
    colorTextBase: "#333333",
    colorBgBase: "#ffffff",
    fontFamily:
      "Barlow, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    borderRadius: 8,
    borderRadiusLG: 10,
  },
}
